<template>
  <div id="app">
    <keep-alive include="layout">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { clearUserProgress } from '@/api/app'
import { mapActions } from 'vuex'
export default {
  mounted() {
    const isClear = false
    if(isClear) {
      clearUserProgress()
    }
    this.getUserInfoFn();
  },
  methods: {
    ...mapActions([
      'getUserInfoFn'
    ]),
  }
};
</script>

<style lang="scss">
#app {
  box-sizing: border-box;
  font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #3e3e3e;
}
</style>
